import React, { Component } from 'react';
import { InventoryBasicSetup } from '../inventorybasicsetup/InventoryBasicSetup';

class BidGroupSetup extends Component {
  render() {
    return (
      <InventoryBasicSetup
        resourceName={'InvGroup/BidGroup'}
        humanName={'Bid Group'}
        {...this.props}
      />
    );
  }
}

export { BidGroupSetup };



// WEBPACK FOOTER //
// ./src/pages/inventory/bidgroupsetup/BidGroupSetup.js